import { Box, Container, Grid, Typography } from "@mui/material";
import IconCard from '../../IconCard/IconCard'
import React from "react";
import {Link} from "react-router-dom";
import {ServicesData} from './ServicesData';

export default function Specialization() {

    return (
        <Box py={6}>
            <Container sx={{ textAlign: 'center' }}>
                <Typography variant="h2" mb={4}>
                    Our Services
                </Typography>

                <Grid
                container
                spacing={{ xs: 1, md: 3 }}
                rowSpacing={{xs:2}}
                mb={5}
                justifyContent={'center'}>
                    {ServicesData.map(item => (
                        <Grid item xs={12} md={3} key={item.title}>
                            <Link to={`/services/${item.id}/${item.slug}`}>
                                <IconCard img={item.icon} title={item.title} bgColor={'#FFFFFF'} shadow={true} />
                            </Link>
                        </Grid>
                    ))}

                </Grid>

                <Link to="/services">
                    <button className="button" disableElevation>
                        View All
                    </button>
                </Link>
            </Container>
        </Box>
    )
}
